module.exports = __webpack_public_path__ + "static/media/shape-yellow.918fb76c.svg";